<template>
  <svg viewBox="0 0 20 20" v-on="$listeners">
    <path 
      fill="currentColor"
      d="M19 4v2H1V4h18zM2 7h16v10H2V7zm11 3V9H7v1h6z"
    >
    </path>
  </svg>
</template>

<script>
export default {
  name: 'archive',
}
</script>